import * as React from 'react';
/**
 *
 * Original name: Stacks
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=49456%3A52
 *
 */
export const StacksLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 4 4.5 8.755 12 13.56l7.5-4.804L12 4Zm0 7.778L7.29 8.762 12 5.776l4.71 2.986L12 11.778Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M18.904 12.697 12 17.119l-6.905-4.422.81-1.264L12 15.338l6.096-3.905.808 1.264Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "m18.905 16.26-.81-1.264L12 18.9l-6.095-3.904-.81 1.263L12 20.682l6.905-4.423Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
